<div>
    <div style="display: flex;">
      <div style="width: 100%">
        <h1 style="font-size: 1.5rem">Professional Info</h1>
      </div>
    </div>

    <lib-content-loader *ngIf="loading"></lib-content-loader>
    <div *ngIf="!loading" [formGroup]="form" style="margin-top: 1rem">

    <div>
        <mat-form-field class="width: 25%;" actions appearance="outline" >
            <mat-label>Organization Name</mat-label>
            <input matInput 
            type="text" 
            formControlName="org_name" required>
            <mat-error *ngIf="form.get('job_title')?.errors">
                Org Name is required.
            </mat-error>
        </mat-form-field>
    </div>

    <div>
        <mat-form-field class="width: 25%;" actions appearance="outline">
            <mat-label>Job Title</mat-label>
            <input matInput type="text" 
            formControlName="job_title" required>
            <mat-error *ngIf="form.get('job_title')?.errors">
                Job title is required.
            </mat-error>
        </mat-form-field>
    </div>

</div>
<div style="padding: 0 4rem 1rem" >
    <lib-button color="primary" style="padding: 5px;" mat-button (click)="router.navigate(['/'])">Back</lib-button>
    <lib-button color="primary" mat-button (click)="update()" [disabled]="!form.valid">Save</lib-button>
</div>
</div>

